import React from 'react';
import ReactDOM from 'react-dom';
import { FixedAspectRatioDiv } from '@rcm/fixed-aspect-ratio-div-react';
import AddToCartPopupContainer from './AddToCartPopupContainer';
import { CartSkuOption } from 'cart-core';
import { GtagCartUpdateMethod } from 'google-analytics/src';

export default function BlockMultiAddToCartController(
  selectorBase: string,
  productId: string,
  image: string,
  skuOptions: CartSkuOption[],
  cart_update_method: GtagCartUpdateMethod,
  uniqueProductIndex: string
) {
  let openPopUp: () => void = () => {};

  const handleAddToCartClick = () => {
    openPopUp();
  };

  const handleMount = (open: () => void) => {
    openPopUp = open;
  };

  /**
   * Replace the image that was rendered by the server for google with a fixed aspect ratio
   * image from react that will work better with responsive design.
   */
  ReactDOM.render(
    <FixedAspectRatioDiv aspectRatio='1:1'>
      <img src={image} />
    </FixedAspectRatioDiv>,
    document.querySelector(selectorBase + ' .imageContainer')
  );

  ReactDOM.render(
    <AddToCartPopupContainer
      cart_update_method={cart_update_method}
      productId={productId}
      skuOptions={skuOptions}
      onMount={handleMount}
      productIndex={uniqueProductIndex}
    />,
    document.querySelector(
      selectorBase + ' .add-to-cart-popup-container-container'
    )
  );

  /**
   * Opens the product options form dialog if the user clicks "add to cart". This Dialog is internally
   * rendered with React.
   */
  document
    .querySelector(selectorBase + ' a.open-add-to-cart-window')
    .addEventListener('click', handleAddToCartClick);
}
